import type { BackendRouteDefinition } from '../types';

// Phase 4 / Sub-phase 5 work block S5-WB5 (PRA-763) flipped this route from
// the `callable` transport to `api`. Requests travel through the Firebase
// Hosting rewrite for `/api/documents/generate{,/**}` to `api-longrun-node`,
// which has the 300 s timeout and document-processing dependencies that the
// standard `api-core-node` profile cannot host. The legacy callable function
// was retired by S7-WB2 (PRA-773); the canonical wire shape is now the zod
// schema in `services/api-longrun-node/src/routes/plugins/generateDocument.ts`.
//
// `path` is the route's leaf — the `/api` prefix is contributed by
// `apiBaseUrl` (see `shared/backend/config.ts` → `resolveApiBaseUrl`, which
// defaults to `/api`). The HTTP transport composes the final URL as
// `${apiBaseUrl}${path}`, so a leading `/api/` here would produce
// `/api/api/documents/generate` and miss the Vite dev proxy / Hosting rewrite
// target.
// Per BE-SVC-03 the legacy `firmId` body field is gone — the route reads
// the firm scope from the verified auth tenant.
interface GenerateDocumentRequestData {
  templateUrl: string;
  inputsUrl: string;
  templateFileName: string;
  inputsFileName: string;
  additionalInstructions?: string;
}

export const generateDocumentRoute = {
  transport: 'api',
  method: 'POST',
  path: '/documents/generate',
  body: (requestData: GenerateDocumentRequestData) => requestData,
} as const satisfies BackendRouteDefinition;
